import React from "react";
import classes from "./Loader.module.css";

const Loader = () => {
  return (
    <div className={classes.Loader_block}>
      <div className={classes.lds_ripple}>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
